<div class="ups-page-header">
    <div class="page-title">{{ pageTitle }}</div>
    <div class="page-actions">
        <ng-content select="[page-actions]"></ng-content>
    </div>
</div>
